import { render, staticRenderFns } from "./ELordIcon.vue?vue&type=template&id=5ab2b91c&"
import script from "./ELordIcon.vue?vue&type=script&lang=js&"
export * from "./ELordIcon.vue?vue&type=script&lang=js&"
import style0 from "./ELordIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports